module.exports = __webpack_public_path__ + "static/media/register_success.4dd39130.svg";